import _toConsumableArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _get from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/get.js";
import _createClass from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _possibleConstructorReturn from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/SUSPENSE.ts
var SUSPENSE = Symbol("SUSPENSE");

// src/StatePromise.ts
var StatePromise = /*#__PURE__*/function (_Promise) {
  function StatePromise(cb) {
    _classCallCheck(this, StatePromise);
    return _callSuper(this, StatePromise, [cb]);
  }
  _inherits(StatePromise, _Promise);
  return _createClass(StatePromise);
}(/*#__PURE__*/_wrapNativeSuper(Promise));

// src/errors.ts
var NoSubscribersError = /*#__PURE__*/function (_Error) {
  function NoSubscribersError() {
    var _this;
    _classCallCheck(this, NoSubscribersError);
    _this = _callSuper(this, NoSubscribersError);
    _this.name = "NoSubscribersError";
    return _this;
  }
  _inherits(NoSubscribersError, _Error);
  return _createClass(NoSubscribersError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var EmptyObservableError = /*#__PURE__*/function (_Error2) {
  function EmptyObservableError() {
    var _this2;
    _classCallCheck(this, EmptyObservableError);
    _this2 = _callSuper(this, EmptyObservableError);
    _this2.name = "EmptyObservableError";
    return _this2;
  }
  _inherits(EmptyObservableError, _Error2);
  return _createClass(EmptyObservableError);
}(/*#__PURE__*/_wrapNativeSuper(Error));

// src/internal/empty-value.ts
var EMPTY_VALUE = {};

// src/state/stateFactory.ts
import { Observable as Observable2 } from "rxjs";

// src/internal/state-observable.ts
import { noop, Observable, Subject, Subscriber } from "rxjs";
var _StateObservable = /*#__PURE__*/function (_Observable) {
  function StateObservable(source$, defaultValue) {
    var _this3;
    var teardown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
    _classCallCheck(this, StateObservable);
    _this3 = _callSuper(this, StateObservable, [function (subscriber) {
      var subscriberWithoutComplete = new Subscriber({
        next: subscriber.next.bind(subscriber),
        error: subscriber.error.bind(subscriber),
        complete: noop
      });
      _this3.refCount++;
      var innerSub;
      subscriber.add(function () {
        var _a;
        _this3.refCount--;
        innerSub.unsubscribe();
        if (_this3.refCount === 0) {
          _this3.currentValue = EMPTY_VALUE;
          if (_this3.subscription) {
            _this3.subscription.unsubscribe();
          }
          teardown();
          (_a = _this3.subject) == null ? void 0 : _a.complete();
          _this3.subject = null;
          _this3.subscription = null;
          if (_this3.promise) {
            _this3.promise.rej(new NoSubscribersError());
            _this3.promise = null;
          }
        }
      });
      if (!_this3.subject) {
        _this3.subject = new Subject();
        innerSub = _this3.subject.subscribe(subscriberWithoutComplete);
        _this3.subscription = null;
        _this3.subscription = new Subscriber({
          next: function next(value) {
            if (_this3.promise && value !== SUSPENSE) {
              _this3.promise.res(value);
              _this3.promise = null;
            }
            _this3.subject.next(_this3.currentValue = value);
          },
          error: function error(err) {
            var _a;
            _this3.subscription = null;
            var subject = _this3.subject;
            _this3.subject = null;
            _this3.currentValue = EMPTY_VALUE;
            var rej = (_a = _this3.promise) == null ? void 0 : _a.rej;
            if (rej && err === SUSPENSE) {
              _this3.promise.rej = function () {
                rej(err);
              };
            }
            subject.error(err);
            if (rej && _this3.promise) {
              _this3.promise.rej = rej;
            }
          },
          complete: function complete() {
            _this3.subscription = null;
            if (_this3.promise) {
              _this3.promise.rej(new EmptyObservableError());
              _this3.promise = null;
            }
            if (_this3.currentValue !== EMPTY_VALUE) return _this3.subject.complete();
            if (defaultValue === EMPTY_VALUE) {
              var subject = _this3.subject;
              _this3.subject = null;
              return subject.error(new EmptyObservableError());
            }
            _this3.subject.next(_this3.currentValue = defaultValue);
            _this3.subject.complete();
          }
        });
        source$.subscribe(_this3.subscription);
        if (defaultValue !== EMPTY_VALUE && _this3.currentValue === EMPTY_VALUE) {
          _this3.subject.next(_this3.currentValue = defaultValue);
        }
      } else {
        innerSub = _this3.subject.subscribe(subscriberWithoutComplete);
        if (_this3.currentValue !== EMPTY_VALUE) {
          subscriber.next(_this3.currentValue);
        }
      }
    }]);
    _this3.defaultValue = defaultValue;
    __publicField(_this3, "subject", null);
    __publicField(_this3, "subscription", null);
    __publicField(_this3, "refCount", 0);
    __publicField(_this3, "currentValue", EMPTY_VALUE);
    __publicField(_this3, "promise", null);
    __publicField(_this3, "pipeState", function () {
      for (var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++) {
        ops[_key] = arguments[_key];
      }
      var result = _superPropGet((_this3, StateObservable), "pipe", _this3, 3)(ops);
      return result instanceof _StateObservable ? result : new _StateObservable(result, EMPTY_VALUE);
    });
    __publicField(_this3, "getRefCount", function () {
      return _this3.refCount;
    });
    __publicField(_this3, "getValue", function () {
      if (_this3.promise) return _this3.promise.p;
      if (_this3.currentValue !== EMPTY_VALUE && _this3.currentValue !== SUSPENSE) return _this3.currentValue;
      if (_this3.defaultValue !== EMPTY_VALUE) return _this3.defaultValue;
      if (_this3.refCount === 0) throw new NoSubscribersError();
      var promise = new StatePromise(function (res, rej) {
        _this3.promise = {
          res: res,
          rej: rej,
          p: null
        };
      });
      _this3.promise.p = promise;
      return promise;
    });
    __publicField(_this3, "getDefaultValue", function () {
      return _this3.defaultValue;
    });
    if (defaultValue === EMPTY_VALUE) {
      delete _this3.getDefaultValue;
    }
    return _this3;
  }
  _inherits(StateObservable, _Observable);
  return _createClass(StateObservable);
}(Observable);

// src/state/stateFactory.ts
function cloneProps(internal, external) {
  external.getValue = internal.getValue;
  external.getRefCount = internal.getRefCount;
  external.pipeState = internal.pipeState;
  if (internal.getDefaultValue) {
    ;
    external.getDefaultValue = internal.getDefaultValue;
  }
}
function connectFactoryObservable(getObservable, defaultValue) {
  var cache = new NestedMap();
  var getDefaultValue = typeof defaultValue === "function" ? defaultValue : function () {
    return defaultValue;
  };
  var getSharedObservables$ = function getSharedObservables$(input) {
    for (var i = input.length - 1; input[i] === void 0 && i > -1; i--) {
      input.splice(-1);
    }
    var keys = [input.length].concat(_toConsumableArray(input));
    var cachedVal = cache.get(keys);
    if (cachedVal !== void 0) {
      return cachedVal;
    }
    var sharedObservable$ = new _StateObservable(getObservable.apply(void 0, _toConsumableArray(input)), getDefaultValue.apply(void 0, _toConsumableArray(input)), function () {
      cache.delete(keys);
    });
    var publicShared$ = new Observable2(function (subscriber) {
      var inCache = cache.get(keys);
      var source$ = sharedObservable$;
      if (!inCache) {
        cache.set(keys, result);
      } else if (inCache !== publicShared$) {
        source$ = inCache;
        cloneProps(source$, publicShared$);
      }
      return source$.subscribe(subscriber);
    });
    cloneProps(sharedObservable$, publicShared$);
    var result = publicShared$;
    cache.set(keys, result);
    return result;
  };
  return function () {
    for (var _len2 = arguments.length, input = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      input[_key2] = arguments[_key2];
    }
    return getSharedObservables$(input);
  };
}
var NestedMap = /*#__PURE__*/function () {
  function NestedMap() {
    _classCallCheck(this, NestedMap);
    __publicField(this, "root");
    this.root = /* @__PURE__ */new Map();
  }
  return _createClass(NestedMap, [{
    key: "get",
    value: function get(keys) {
      var current = this.root;
      for (var i = 0; i < keys.length; i++) {
        current = current.get(keys[i]);
        if (!current) return void 0;
      }
      return current;
    }
  }, {
    key: "set",
    value: function set(keys, value) {
      var current = this.root;
      var i;
      for (i = 0; i < keys.length - 1; i++) {
        var nextCurrent = current.get(keys[i]);
        if (!nextCurrent) {
          nextCurrent = /* @__PURE__ */new Map();
          current.set(keys[i], nextCurrent);
        }
        current = nextCurrent;
      }
      current.set(keys[i], value);
    }
  }, {
    key: "delete",
    value: function _delete(keys) {
      var maps = [this.root];
      var current = this.root;
      for (var i = 0; i < keys.length - 1; i++) {
        maps.push(current = current.get(keys[i]));
      }
      var mapIdx = maps.length - 1;
      maps[mapIdx].delete(keys[mapIdx]);
      while (--mapIdx > -1 && maps[mapIdx].get(keys[mapIdx]).size === 0) {
        maps[mapIdx].delete(keys[mapIdx]);
      }
    }
  }]);
}();

// src/state/stateSingle.ts
function state(observable, defaultValue) {
  return new _StateObservable(observable, defaultValue);
}

// src/state/index.ts
var state2 = function state2() {
  return (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "function" ? connectFactoryObservable : state)(arguments.length <= 0 ? undefined : arguments[0], arguments.length > 1 ? arguments.length <= 1 ? undefined : arguments[1] : EMPTY_VALUE);
};

// src/withDefault.ts
var withDefault = function withDefault(defaultValue) {
  return function (source$) {
    return state2(source$, defaultValue);
  };
};

// src/effects/sinkSuspense.ts
import { Observable as Observable3, Subscriber as Subscriber2 } from "rxjs";
var sinkSuspense = function sinkSuspense() {
  return function (source$) {
    var waiting = null;
    return new Observable3(function (observer) {
      if (waiting) {
        waiting.inner = observer;
        var outter2 = waiting;
        return function () {
          if (outter2.inner === observer) outter2.unsubscribe();
        };
      }
      var outter = new Subscriber2({
        next: function next(value) {
          if (value === SUSPENSE) {
            waiting = outter;
            outter.inner.error(value);
            waiting = null;
            if (outter.inner === observer) {
              outter.unsubscribe();
            }
          } else {
            outter.inner.next(value);
          }
        },
        error: function error(e) {
          outter.inner.error(e);
        },
        complete: function complete() {
          outter.inner.complete();
        }
      });
      outter.inner = observer;
      source$.subscribe(outter);
      return function () {
        if (outter.inner === observer) outter.unsubscribe();
      };
    });
  };
};

// src/effects/liftSuspense.ts
import { Observable as Observable4, Subscriber as Subscriber3 } from "rxjs";
var liftSuspense = function liftSuspense() {
  return function (source$) {
    return new Observable4(function (observer) {
      var subscriber;
      var _setSubscriber = function setSubscriber() {
        subscriber = new Subscriber3({
          next: function next(v) {
            observer.next(v);
          },
          error: function error(e) {
            if (e === SUSPENSE) {
              observer.next(e);
              _setSubscriber();
            } else observer.error(e);
          },
          complete: function complete() {
            observer.complete();
          }
        });
        source$.subscribe(subscriber);
      };
      _setSubscriber();
      return function () {
        subscriber.unsubscribe();
      };
    });
  };
};
export { EmptyObservableError, NoSubscribersError, SUSPENSE, StatePromise, liftSuspense, sinkSuspense, state2 as state, withDefault };